<template>
	<div class="page">
		<div class="screenLine">
			<el-input v-model="params.keyword" @keyup.enter.native="changeSearch" placeholder="输入关键字" style="width:240px;margin-right: 16px;"></el-input>
			<el-select v-model="params.shopId" class="titleSelect" @change="changeSearch">
				<el-option v-for="item in [{shop_name:'全部门店',shop_id:''}].concat(shopList)" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id" >
				</el-option>
			</el-select>
			<el-select v-model="params.stockStatus" @change="changeSearch" placeholder="是否有库存" style="width:130px;margin-right: 16px;">
				<el-option popper-class="select" v-for="item in [{label:'全部库存',value:-1},{label:'无库存',value:0},{label:'有库存',value:1}]" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			<el-select v-model="params.applyType" placeholder="适用宠物" style="width:130px;margin-right: 16px;" @change="changeSearch">
				<el-option v-for="item in [{label:'全部种类',value:-1},{label:'通用',value:0},{label:'猫',value:1},{label:'狗',value:2}]" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
		</div>
		<div class="tabLine">
			<div class="tabItem" :class="[tabs==1?'active':'']" @click="handleTabClick(1)">商品</div>
			<div class="tabItem" :class="[tabs==2?'active':'']" @click="handleTabClick(2)">药品</div>
			<div class="tabItem" :class="[tabs==3?'active':'']" @click="handleTabClick(3)">耗材</div>
		</div>
		<div class="pageConBox">
			<div class="navBox">
				<el-tree :data="categoryList" :highlight-current='true' node-key="id" default-expand-all :expand-on-click-node="false" @node-click='handleNodeClick'>
				</el-tree>
			</div>
			<div class="tables">
				<div class="tableBox" ref="tableBox">
					<el-table v-if="tabs==1" :data="goodsData" style="width: 100%" ref='table1' height="100%" row-class-name="row-expand-cove">
						<el-table-column prop="title" label="名称" width="180" :key="Math.random()">
							<template slot-scope="scope">
								<div v-if="$public.isNull(scope.row.cover)">{{scope.row.title}}</div>
								<el-tooltip v-else placement="top" effect="light">
									<div slot="content">
										<img :src="scope.row.cover" style="width:300px;" />
									</div>
									<div>{{scope.row.title}}</div>
								</el-tooltip>
							</template>
						</el-table-column>
						<el-table-column label="适用" width="70">
							<template slot-scope="scope">
								<span>{{scope.row.apply_type.title}}</span>
							</template>
						</el-table-column>
						<el-table-column label="品牌" width="80">
							<template slot-scope="scope">
								{{scope.row.brand_name}}
							</template>
						</el-table-column>
						<el-table-column label="分类" width="80">
							<template slot-scope="scope">
								{{scope.row.category_info.name}}
							</template>
						</el-table-column>
						<el-table-column label="规格/包装/售价/库存">
							<template slot-scope="scope">
								<div>
									<div style="display: flex;padding:5px;" v-for="(item,index) in scope.row.skus_list" :key="index">
										<div class="column" style="width:200px;margin-right: 20px;">
											<span>
												<span v-if="$public.isNull(item.image)">{{FSkuName(item.skus_name)}}</span>
												<el-tooltip v-else placement="top" effect="light">
													<div slot="content">
														<img :src="item.image[0]" style="width:300px;" />
													</div>
													<span>{{FSkuName(item.skus_name)}}</span>
												</el-tooltip>
											</span>
										</div>
										<div class="column" style="width:100px">
											<div style="margin:1px;" v-for="(item1,index1) in item.sale_way" :key="index1">
												{{item1.packing_way_name}}
												<span style="margin:0 10px;">￥{{item1.pprice}}</span>
											</div>
										</div>
										<div class="column">
											<div style="margin:1px;" v-for="(item1,index1) in item.stock" :key="index1">
												<el-button icon="el-icon-view" style="padding: 0; margin-left: 10px;" @click="getCustomCode(scope.row,item,{shopId:item1.shopId,shopName:item1.shopName},'0')">
												</el-button>
												<span style="margin:0 5px;">{{item1.shopName}}:{{item1.stock}}</span>
											</div>
										</div>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column type="expand" v-loading="loadtable" width="1">
							<template slot-scope="scope">
								<div v-if="loadtable" style="text-align: center;">
									<i class="el-icon-loading" style="font-size: 30px;"></i>
								</div>
								<div v-else style="padding:0px 20px;">
									<div>{{scope.row.title}} <span style="color:red">( {{customCodeData.skuValue}} )</span> [ {{customCodeData.shopName}} ]</div>
									<el-form label-position="left" class="demo-table-expand">
										<el-form-item>
											<el-tag style="margin: 5px;" v-for="(item) in customCodeData.customCode" :key="item.customCode">
												{{item.customCode}}
												<span style="margin-left: 10px; color: #8E71E4">
													总量 <span style="color: #8E71E4">{{item.totaTimes }}</span>
												</span>
												<span style="margin-left: 10px; color: #FC6F6F">
													已使用量 <span style="color: #FC6F6F">{{item.useTimes}}</span>
												</span>
												<span style="margin-left: 10px; color: #67c23a">
													剩余量 <span style="color: #67c23a">{{item.totaTimes - item.useTimes}}</span>
												</span>
											</el-tag>
										</el-form-item>
									</el-form>
								</div>
							</template>
						</el-table-column>
					</el-table>
					<template v-if="tabs==2">
						<el-table :data="medicalData" style="width: 100%" ref='table2' height="100%" row-class-name="row-expand-cove">
							<el-table-column prop="title" label="项目名称" :key="Math.random()" min-width="180">
								<template slot-scope="scope">
									<div v-if="$public.isNull(scope.row.cover)">{{scope.row.title}}</div>
									<el-tooltip v-else placement="top" effect="light">
										<div slot="content">
											<img :src="scope.row.cover" style="width:300px;" />
										</div>
										<div>{{scope.row.title}}</div>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column prop="name" label="适用" :key="Math.random()" width="60">
								<template slot-scope="scope">
									<span>{{scope.row.apply_type.title}}</span>
								</template>
							</el-table-column>
							<el-table-column label="品牌" :key="Math.random()" width="80">
								<template slot-scope="scope">
									<span>{{scope.row.brand_name}}</span>
								</template>
							</el-table-column>
							<el-table-column label="规格" :key="Math.random()" width="110">
								<template slot-scope="scope">
									<span>{{scope.row.old_packinfo_info.sku_value}}</span>
								</template>
							</el-table-column>
							<el-table-column label="分类" :key="Math.random()" width="110">
								<template slot-scope="scope">
									<span>{{scope.row.category_info.name}}</span>
								</template>
							</el-table-column>
							<el-table-column label="价格" prop="pprice" :key="Math.random()" width="80">
								<template slot-scope="scope">
									<span>{{scope.row.pprice}}</span>
								</template>
							</el-table-column>
							<el-table-column label="库存" width="400">
								<template slot-scope="scope">
									<div style="margin:1px;" v-for="(stockitem,key) in scope.row.stock" :key="key">
										<el-button icon="el-icon-view" style="padding: 0; margin-left: 5px;" @click="getCustomCode(scope.row,{},{shopId:stockitem.shopId,shopName:stockitem.shopName},'1')">
										</el-button>
										<span style="margin:0 10px;">{{stockitem.shopName}}:{{stockitem.stock}}</span>
									</div>
								</template>
							</el-table-column>
							<el-table-column type="expand" v-loading="loadtable" width="1">
								<template slot-scope="scope">
									<div v-if="loadtable" style="text-align: center;">
										<i class="el-icon-loading" style="font-size: 30px;"></i>
									</div>
									<div v-else style="padding:0px 20px;">
										<div>{{scope.row.title}} [ {{customCodeData.shopName}} ]</div>
										<el-form label-position="left" class="demo-table-expand">
											<el-form-item>
												<el-tag style="margin: 5px;" v-for="(item) in customCodeData.customCode" :key="item.customCode">
													{{item.customCode}}
													<span style="margin-left: 10px; color: #8E71E4">
														总量 <span style="color: #8E71E4">{{item.totaTimes }}</span>
													</span>
													<span style="margin-left: 10px; color: #FC6F6F">
														已使用量 <span style="color: #FC6F6F">{{item.useTimes}}</span>
													</span>
													<span style="margin-left: 10px; color: #67c23a">
														剩余量 <span style="color: #67c23a">{{item.totaTimes - item.useTimes}}</span>
													</span>
												</el-tag>
											</el-form-item>
										</el-form>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</template>
					<el-table v-if="tabs == 3" :data="consumablesData" style="width: 100%" ref='table3' height="100%" row-class-name="row-expand-cove">
						<el-table-column prop="title" label="名称" :key="Math.random()" width="180px">
							<template slot-scope="scope">
								<div v-if="$public.isNull(scope.row.cover)">{{scope.row.title}}</div>
								<el-tooltip v-else placement="top" effect="light">
									<div slot="content">
										<img :src="scope.row.cover" style="width:300px;" />
									</div>
									<div>{{scope.row.title}}</div>
								</el-tooltip>
							</template>
						</el-table-column>
						<el-table-column label="分类" :key="Math.random()" width="80px">
							<template slot-scope="scope">
								<span>{{scope.row.category_info.name}}</span>
							</template>
						</el-table-column>
						<el-table-column label="是否限制" :key="Math.random()" width="80px">
							<template slot-scope="scope">
								<span v-if="scope.row.count_limit==0">不限制</span>
								<span v-else>限制</span>
							</template>
						</el-table-column>
						<el-table-column label="包装单位" prop="packing_unit" >
						</el-table-column>
						<el-table-column label="使用单位" prop="use_unit" width="80px">
						</el-table-column>
						<el-table-column label="建议使用次数" prop="use_times" width="100px">
						</el-table-column>
						<el-table-column label="库存" :key='3' width="300px">
							<template slot-scope="scope">
								<div style="margin:1px;" v-for="(stockitem,key) in scope.row.stock" :key="key">
									<el-button icon="el-icon-view" style="padding: 0; margin-left: 5px;" @click="getCustomCode(scope.row,{},{shopId:stockitem.shopId,shopName:stockitem.shopName},'7')">
									</el-button>
									<span style="margin:0 30px;">{{stockitem.shopName}}:{{stockitem.stock}}</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column type="expand" v-loading="loadtable" width="1">
							<template slot-scope="scope">
								<div v-if="loadtable" style="text-align: center;">
									<i class="el-icon-loading" style="font-size: 30px;"></i>
								</div>
								<div v-else style="padding:0px 20px;">
									<div>{{scope.row.title}} [ {{customCodeData.shopName}} ]</div>
									<el-form label-position="left" class="demo-table-expand">
										<el-form-item>
											<el-tag style="margin: 5px;" v-for="(item) in customCodeData.customCode" :key="item.customCode">
												{{item.customCode}}
												<span style="margin-left: 10px; color: #8E71E4">
													总量 <span style="color: #8E71E4">{{item.totaTimes }}</span>
												</span>
												<span style="margin-left: 10px; color: #FC6F6F">
													已使用量 <span style="color: #FC6F6F">{{item.useTimes}}</span>
												</span>
												<span style="margin-left: 10px; color: #67c23a">
													剩余量 <span style="color: #67c23a">{{item.totaTimes - item.useTimes}}</span>
												</span>
											</el-tag>
										</el-form-item>
									</el-form>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="pagePosi">
					<page style="padding:10px 0;" :page="page.page" :total="page.total" :pageSize="page.pageSize" @change="changePage"></page>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import page from "../../../components/page.vue"
	export default {
		components: {page},
		data() {
			return {
				params: {
					keyword: '',
					shopId: '',
					stockStatus: -1, // -1 不限 0无库存 1有库存
					applyType: -1, //  -1全部 0通用 1猫 2狗
					categoryId: '',
				},
				shopList:this.$store.state.allShopList,
				categoryList: [],
				tabs: 1,
				
				page: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				goodsData: [],
				medicalData: [],
				consumablesData: [],
				
				//条码显示格式
				loadtable: false,
				customCodeData: {
					skuValue: '',
					shopName: '',
					customCode: [],
				},
			}
		},
		computed: {
		},
		mounted() {
			this.getCategoryList(this.tabs);
			this.getTableData();
		},
		methods: {
			// 切换 商品 药品 耗材
			handleTabClick(tab) {
				this.tabs = tab;
				this.params.categoryId = '';
				this.page.page = 1;
				this.getTableData()
				this.getCategoryList(this.tabs);
			},
			// 分类树
			handleNodeClick(data) {
				this.params.categoryId = data.id;
				this.page.page=1;
				this.getTableData()
				// this.$refs.tableBox.scrollTop = 0
			},
			getCategoryList(tab) {
				let params = {}
				if (tab === 1) {
					params.category = '商品'
				} else if (tab === 2) {
					params.category = '医疗'
				} else  if (tab === 3){
					params.category = '耗材'
				}
				this.$http.get(process.env.VUE_APP_baseData+'/api/dict/ProductType/tree', params).then(res => {
					if (res.code == 0) {
						this.categoryList = res.data[0].children;
						this.recursion(this.categoryList);
					}
				})
			},
			// 递归
			recursion(arr) {
				for (let i = 0; i < arr.length; i++) {
					if (arr[i].children == null || arr[i].children.length == 0) {
						arr[i].children = null;
					} else {
						this.recursion(arr[i].children);
					}
				}
			},
			// 获取列表数据
			changeSearch() {
				this.page.page = 1;
				this.getTableData()
			},
			changePage(num) {
				this.page.page = num;
				this.getTableData()
			},
			getTableData(){
				if (this.tabs == 1) {
					let params = this.params
					params.pageIndex = this.page.page
					params.pageSize = this.page.pageSize
					this.$http.post(process.env.VUE_APP_baseData + '/api/product/goods/list', params).then(res => {
						if (res.code == 0) {
							this.goodsData = res.data.data;
							this.page.total = res.data.count;
						}
					})
				} else if (this.tabs == 2) {
					let params = this.params
					params.pageIndex = this.page.page
					params.pageSize = this.page.pageSize
					this.$http.post(process.env.VUE_APP_baseData + '/api/product/medical/list', params).then(res => {
						if (res.code == 0) {
							this.medicalData = res.data.data;
							this.page.total = res.data.count;
						}
					})
				} else if (this.tabs == 3){
					let params = this.params
					params.pageIndex = this.page.page
					params.pageSize = this.page.pageSize
					this.$http.post(process.env.VUE_APP_baseData + '/api/product/consumableMaterial/list', params).then(res => {
						if (res.code == 0) {
							this.consumablesData = res.data.data;
							this.page.total = res.data.count;
						}
					})
				}
			},
			// 格式化库存信息
			FSkuName(str) {
				let s = ''
				let arr = str.split(',')
				for (let i = 0; i < arr.length; i++) {
					s += arr[i].split(":")[1] + '，'
				}
				return s.substr(0, s.length - 1);
			},
			//点击眼睛或查看条码请求条码列表
			getCustomCode(goodsitem, skuitem, stockitem, type) {
				console.log(this.$refs.table3, goodsitem, skuitem, stockitem, type)
				if (type === '0') {
					this.loadtable = true;
					let $table = this.$refs.table1;
					this.goodsData.map(ele => {
						if (ele.goodsId != goodsitem.goodsId) {
							$table.toggleRowExpansion(ele, false)
						}
					})
					$table.toggleRowExpansion(goodsitem, true)
				} else if (type === '1'){
					this.loadtable = true;
					let $table = this.$refs.table2;
					this.medicalData.map(ele => {
						if (ele.medical_id != goodsitem.medical_id) {
							$table.toggleRowExpansion(ele, false)
						}
					})
					$table.toggleRowExpansion(goodsitem, true)
				}else if (type === '7'){
					this.loadtable = true;
					let $table = this.$refs.table3;
					this.consumablesData.map(ele => {
						if (ele.consumablematerial_id != goodsitem.consumablematerial_id) {
							$table.toggleRowExpansion(ele, false)
						}
					})
					$table.toggleRowExpansion(goodsitem, true)
				}
				let params = {
					shopId: stockitem.shopId,
					goodsId: goodsitem.goodsId||goodsitem.medical_id||goodsitem.consumablematerial_id,
					sku: type === '0' ? skuitem._id : '',
					goodsType: type,  // 0商品 1药品 7耗材
					modestate: 1,  // 0全部 1(已入库,使用中,未使用)
					pageIndex: 0,
					pageSize: 0,
				}
				this.$http.post(process.env.VUE_APP_kucun + '/api/Goods/CustomCodeGoodsList', params).then(res => {
					this.loadtable = false;
					if (res.code === 0) {
						this.customCodeData.skuValue = skuitem.skus_name||'';
						this.customCodeData.shopName = stockitem.shopName||'';
						this.customCodeData.customCode = res.data.data||[];
					}
				})
			},
		}
	}
</script>
<style lang="scss" scoped="scoped">
	.page {
		padding:16px 16px 0px 16px;height: 100%;box-sizing: border-box;position: relative;

		.screenLine {
			display: flex;
			.screenLineR{
				flex: 1;
				display: flex;
				justify-content: flex-end;
				.tabView{
					display: flex;
					align-items: center;
					width: 278px;
					height: 44px;
					background: #E7E7F4;
					border-radius: 10px;
					justify-content: space-around;
					.tabItem{
						width: 90px;
						height: 36px;
						font-size: 14px;
						text-align: center;
						line-height: 36px;
						border-radius: 8px;
					}
					.tabActiveItem{
						width: 90px;
						height: 36px;
						font-size: 14px;
						text-align: center;
						line-height: 36px;
						border-radius: 8px;
						background: #3A6DFF;
						color: #fff;
					}
				}
			}
			.titleSelect{
				width: 130px;
				margin-right: 16px;
			}
		}

		.tabLine {
			margin-top: 12px;
			display: flex;

			.tabItem {
				padding: 0 16px;
				line-height: 36px;
				text-align: center;
				border-right: 1px solid #F2F2F2;
				cursor: pointer;
				font-size: 14px;
				background-color: #fff;

				&.active {
					color: red;
				}
			}
		}

		.pageConBox {
			display: flex;
			border-top: 1px solid #F2F2F2;
			height: calc(100% - 100px);

			.navBox {
				width: 160px;
				padding: 10px;
				height: 100%;
				border-radius: 6px;
				background-color: #fff;
				border-right: 13px solid #f5f5f5;
				overflow: auto;
				box-sizing: border-box;

				.navItem {
					line-height: 40px;
					padding-left: 20px;
					cursor: pointer;

					.active {
						color: #1890FF
					}
				}

				&::-webkit-scrollbar {
					width: 4px;
					// height: 4px;
				}

				::v-deep.el-collapse-item__wrap {
					border: 0;
				}

				::v-deep.el-collapse-item__header {
					border: 0;
				}

				::v-deep.el-collapse {
					border: 0;
				}

				::v-deep .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
					background-color: red;
					border-radius: 4px;
					color: #fff;
				}
			}
			.tables{
				position: relative;width: calc(100% - 160px);
				.tableBox {
					height: calc(100% - 60px);
				}
				.pagePosi {
					position: absolute;
					bottom: 0;
					left: 0px;
					right: 0px;
					text-align: right;
					background-color: #fff;
					padding: 0 10px;
					border-radius: 8px 8px 0 0;
				}
			}
		}

		
		

		.el-table__expand-icon {
			height: 0;

		}
		
	}
</style>
